import { Component, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MustMatch } from './mustMatch';
import { ToastrService } from 'ngx-toastr';
import { AccountService } from 'src/app/shared/services/admServices/accounts.service';
import { SharedService } from 'src/app/shared/services/sharedServices/shared.service';
import { myProfile, AccountUpdate, Password } from 'src/app/models/admModel/account.model';

@Component({
  selector: 'adm-dash-component',
  templateUrl: './profile-component.html',
  styleUrls: ['./profile-component.scss']
})

export class accprofileComponent implements OnInit {
  passwordForm: FormGroup;
  profileForm: FormGroup;

  currentAccount = new myProfile();
  currentAccountUpdate = new AccountUpdate();
  password = new Password();
  countryData: any;
  flag: any;
  checkAdminStat?: boolean;
  checkPublisherStat: boolean;
  show: boolean;
  roles: any[] = [];
  rolesName: string[] = [];
  urlImage: any;

  defaultPayoutTermList = [
    { value: 1, label: 'every week' },
    { value: 2, label: 'biweekly' },
    { value: 3, label: 'every three weeks' },
    { value: 4, label: 'every four weeks' },
  ];

  constructor(public fb: FormBuilder,
    public fbpro: FormBuilder,
    private toastrService: ToastrService,
    private accountService: AccountService,
    private sharedServices: SharedService)
    {}

  ngOnInit() {
    this.getCountries();
    this.getAccount();

    this.createPasswordForm();
    this.createProfileForm();
  }

  getCountries(): void {
    this.sharedServices.getAllCountries()
    .subscribe(
     data => {
       this.countryData = data.data.countries;
     },
     error => {
       console.log(error);
     });
  }

  getAccount(): void {
    this.accountService.getMyProfile()
      .subscribe(
        data => {
          this.currentAccount = data.data;

          if(this.currentAccount.profileImage==null)
            this.urlImage = '../../../../../assets/images/user/user2.png';
          else
            this.urlImage = this.currentAccount.profileImage;

          for(let i=0;i<data.data.roles.length;i++)
            this.rolesName[i]=data.data.roles[i].name

          if(this.rolesName.includes('ROLE_ADMIN'))
            this.checkAdminStat=true;
          else
            this.checkAdminStat=false;

          if(this.rolesName.includes('ROLE_PUBLISHER'))
            this.checkPublisherStat=true;
          else
            this.checkPublisherStat=false;

          this.show = this.checkPublisherStat;

          this.setProfileForm();
        },
        error => {
          console.log(error);
        });
  }

  createPasswordForm() {
    this.passwordForm = this.fb.group({
      passwordCurrent: ['', [Validators.required, Validators.minLength(8)]],
      passwordNew: [null, [Validators.required, Validators.minLength(8)]],
      confirmPassword: [null, Validators.required],
    }, {
      validator: MustMatch('passwordNew', 'confirmPassword')
    });
  }

  createProfileForm(){
    this.profileForm = this.fbpro.group({
      company: [''],
      checkAdmin: [{value: false, disabled: true}],
      checkPublisher: [{value: false}],
      tax: [''],
      userName: [this.currentAccount.username, Validators.required],
      email: [this.currentAccount.email, Validators.required],
      firstName: [this.currentAccount.firstName, Validators.required],
      lastName: [this.currentAccount.lastName, Validators.required],
      street: ['', Validators.required],
      cityName: ['', Validators.required],
      zip: ['', Validators.required],
      country: [null, Validators.required],
      payterm: [ null, Validators.required],
      rate: [null, Validators.required],
      notes: [null]
    });
  }

  setFlag(event){
    this.flag = this.countryData[this.profileForm.get('country')!.value-1].alpha2Code;
  }

  setProfileForm(){
    this.profileForm.setValue({
      userName: this.currentAccount.username,
      firstName: this.currentAccount.firstName,
      lastName: this.currentAccount.lastName,
      email: this.currentAccount.email,
      company: this.currentAccount.company,
      tax: this.currentAccount.tax,
      street: this.currentAccount.address,
      zip: this.currentAccount.zipCode,
      cityName: this.currentAccount.city,
      country: this.currentAccount.country.id,
      payterm: this.currentAccount.payoutTerm.id,
      rate: this.currentAccount.rate,
      notes: this.currentAccount.about,
      checkAdmin: this.checkAdminStat,
      checkPublisher: this.checkPublisherStat
    });
    this.flag = this.currentAccount.country.alpha2Code;
  }

  setPublisher(event){
    if(this.profileForm.get('checkPublisher')!.value)
      this.show=true;
    else
      this.show=false;
  }

  onSave() {
    this.password.currentPassword = this.passwordForm.get('passwordCurrent')!.value;
    this.password.repeatNewPassword = this.passwordForm.get('confirmPassword')!.value;
    this.password.newPassword = this.passwordForm.get('passwordNew')!.value;

    this.accountService.changePass(this.password)
    .subscribe(
      data => {
        if(data.errors)
        {
          // error
          this.passwordForm.reset();
          this.toastrService.error(data.errors[0].message, 'Error !');
        }
        else
        {
          // poprawnie zmieniono hasło
          this.toastrService.success('New password properly changed.', 'Success !');
          this.passwordForm.reset();
        }
      },
      error => {
        console.log(error);
        this.toastrService.error('Change password failed.', 'Error');
      });
  }

  onUpdate() {
    this.currentAccountUpdate.username = this.profileForm.get('userName')!.value
    this.currentAccountUpdate.firstName = this.profileForm.get('firstName')!.value;
    this.currentAccountUpdate.lastName = this.profileForm.get('lastName')!.value;
    this.currentAccountUpdate.company = this.profileForm.get('company')!.value;
    this.currentAccountUpdate.profileImage = null;
    this.currentAccountUpdate.tax = this.profileForm.get('tax')!.value;
    this.currentAccountUpdate.email = this.profileForm.get('email')!.value;
    this.currentAccountUpdate.city = this.profileForm.get('cityName')!.value;
    this.currentAccountUpdate.zipCode = this.profileForm.get('zip')!.value;
    this.currentAccountUpdate.countryId = this.profileForm.get('country')!.value;
    if(this.profileForm.get('checkPublisher')!.value && this.profileForm.get('checkAdmin')!.value)
    {
      // obie role wybrane
      this.currentAccountUpdate.roleIds[0] = 1;
      this.currentAccountUpdate.roleIds[1] = 2;
    }
    else
    {
      // tylko jedna jakaś rola
      if(this.profileForm.get('checkPublisher')!.value || this.profileForm.get('checkAdmin')!.value)
      {
        // jakaś rola ustawiona
        if(this.profileForm.get('checkPublisher')!.value)
          this.currentAccountUpdate.roleIds[0] = 2;
        if(this.profileForm.get('checkAdmin')!.value)
          this.currentAccountUpdate.roleIds[0] = 1;
      }
      else
        // zabezpieczenie jeżeli nic nie zostanie wybrane to zawsze przypisuje publishera
        this.currentAccountUpdate.roleIds[0] = 2;
    }
    this.currentAccountUpdate.about = this.profileForm.get('notes')!.value;
    this.currentAccountUpdate.address = this.profileForm.get('street')!.value;
    this.currentAccountUpdate.rate = this.profileForm.get('rate')!.value;
    this.currentAccountUpdate.paymentTerm = Number(this.profileForm.get('payterm')!.value);

    console.log("DATA: ", this.currentAccountUpdate);
    this.accountService.updateMyProfile(this.currentAccountUpdate)
    .subscribe(
      data => {
        if(data.errors)
        {
          this.toastrService.error(data.errors[0].message, 'Error !');
        }
        else
        {
          this.toastrService.success('My Profile data updated.', 'Success !');
        }
      },
      error => {
        console.log(error);
      });
  }
}
